module.exports = __webpack_public_path__ + "static/media/calculator.81b30593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/calculator.png
// module id = 832
// module chunks = 42